import { BRANDS } from "@/data/site";

export default function BrandMarquee() {
  const doubled = [...BRANDS, ...BRANDS];
  return (
    <div
      data-testid="brand-marquee"
      className="relative overflow-hidden border-y border-slate-200 bg-white py-7"
    >
      <div
        className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent"
        aria-hidden="true"
      />
      <div className="marquee-track flex w-max items-center gap-12 pr-12">
        {doubled.map((brand, i) => (
          <span
            key={`${brand.name}-${i}`}
            className="font-mono text-base uppercase tracking-[0.32em] text-slate-500 transition-colors duration-300 hover:text-cyan-700"
          >
            {brand.name}
          </span>
        ))}
      </div>
    </div>
  );
}
